<template>
  <v-card>
    <v-row v-if="!isMobile" align="center">
      <v-col md="auto">
        <v-img
          :src='image'
          width='200px'
          class="ml-4 my-2"
        />
      </v-col>

      <v-col>
        <v-card-title>{{name}}</v-card-title>
        <v-card-text>
          {{bio}}
        </v-card-text>
      </v-col>
    </v-row>

    <div v-if="isMobile">
      <v-img :src='"/mobile" + image' height='300px'></v-img>

      <v-card-title>{{name}}</v-card-title>

      <v-card-text>
        <CollapsedText :text="bio" />
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import CollapsedText from './CollapsedText.vue';

export default {
  components: {
    CollapsedText,
  },

  props: ['image', 'name', 'bio', 'isMobile'],
};
</script>
